export function getLegacyRedirectPath(target) {
  if (!target) {
    return '/archive';
  }

  return String(target).startsWith('/') ? String(target) : `/show/${target}`;
}

// A retired shows-like slug follows its show: to the show's shows-like page
// when one is published, otherwise to the show page.
export function getLegacyShowsLikeRedirectPath(target, showsLikeSlugs = new Set()) {
  if (!target || String(target).startsWith('/')) {
    return getLegacyRedirectPath(target);
  }

  return showsLikeSlugs.has(target) ? `/shows-like/${target}` : `/show/${target}`;
}
